import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deletePlanejamento } from '../service';
import {
  DELETE_PLANEJAMENTO,
  DELETE_PLANEJAMENTO_PENDING,
  DELETE_PLANEJAMENTO_SUCCESS,
  DELETE_PLANEJAMENTO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeletePlanejamento(action) {
  yield put({ type: DELETE_PLANEJAMENTO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.PLANEJAMENTO_SAFRA_EXCLUIR);

  try {
    const a = yield call(deletePlanejamento, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PLANEJAMENTO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PLANEJAMENTO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeletePlanejamento() {
  yield takeLatest(DELETE_PLANEJAMENTO, sagaDeletePlanejamento)
}
